<script lang="ts">
  import {onMount} from 'svelte'
  import {default as MediumEditor} from 'medium-editor'

  export let content: string
  export let placeholder: string
  let div: HTMLDivElement
  let editor: any

  onMount(() => {
    editor = new MediumEditor(div, {
      toolbar: {
        buttons: ['bold', 'italic', 'anchor']
      },
      placeholder: {
        text: placeholder,
        hideOnClick: true
      }
    })

    editor.subscribe('editableInput', () => {
      content = editor.getContent()
    })

    editor.setContent(content ?? '')
  })
</script>

<div bind:this={div} class={$$props.class ?? ''}/>
